import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import config from "../../Config";
import TransportMenu from "./TransportMenu";
import imgTransport from "../../assets/images/dashboard_icon/bus_route.svg";
import { scrollToTop } from "../Shared/ScrollOnTop";

const busAccentColors = ["#003970", "#0d6efd", "#6f42c1", "#198754", "#fd7e14", "#dc3545"];

const TransportDashboard = () => {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));
  const [loadingBuses, setLoadingBuses] = useState(true);
  const [busRoutes, setBusRoutes] = useState([]);

  useEffect(() => {
    document.title = "Transport";
  }, []);

  useEffect(() => {
    setLoadingBuses(true);

    axios({
      method: "post",
      url: config.base_url + "Busroute/GetBusRoutes",
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        AccessKey: AccessKey,
        UserID: UserID,
        MemberType: MemberType,
        pageNo: 1,
        pageSize: 1000,
        Root_Code: "",
        Area_Name: "",
        BusNumber: "",
        SchoolID: 1,
      },
    })
      .then(function (response) {
        setBusRoutes(response.data.ListofRecords || []);
        setLoadingBuses(false);
      })
      .catch(function () {
        setLoadingBuses(false);
      });
  }, [AccessKey, UserID, MemberType]);

  const busWiseCounts = useMemo(() => {
    const counts = {};
    (busRoutes || []).forEach((item) => {
      const busNo = (item.BusNumber || "").trim();
      if (!busNo) {
        return;
      }
      const studentCount = Number(item.NoofStudents || 0);
      counts[busNo] = (counts[busNo] || 0) + (Number.isNaN(studentCount) ? 0 : studentCount);
    });

    return Object.keys(counts)
      .sort((a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" }))
      .map((busNo) => ({
        busNo,
        studentCount: counts[busNo],
      }));
  }, [busRoutes]);

  const totalBusStudents = useMemo(() => {
    return busWiseCounts.reduce((sum, item) => sum + (Number(item.studentCount) || 0), 0);
  }, [busWiseCounts]);

  return (
    <>
      <TransportMenu />
      <div className="page-head">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/Dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Transport
                  </li>
                </ol>
              </nav>
              <div className="page-title">Transport</div>
            </div>
          </div>
        </div>
      </div>

      <div className="page-content">
        <div className="container">
          <div className="row align-items-center g-3">
            <div className="col-md-4 col-sm-6">
              <Link
                to="/Transport/RoutesReport"
                onClick={scrollToTop}
                className="card m-card text-decoration-none"
              >
                <div className="card-body text-center">
                  <img src={imgTransport} className="pb-3" alt="" />
                  <p className="m-2 mt-0">Routes Report</p>
                  <span className="text-icon sky">
                    View Report <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </Link>
            </div>
            <div className="col-md-4 col-sm-6">
              <Link
                to="/Transport/ManageBusRoutes"
                onClick={scrollToTop}
                className="card m-card text-decoration-none"
              >
                <div className="card-body text-center">
                  <img src={imgTransport} className="pb-3" alt="" />
                  <p className="m-2 mt-0">Manage Bus Routes</p>
                  <span className="text-icon pink">
                    Open Setup <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </Link>
            </div>
            <div className="col-md-4 col-sm-6">
              <Link
                to="/Transport/ManageRouteSections"
                onClick={scrollToTop}
                className="card m-card text-decoration-none"
              >
                <div className="card-body text-center">
                  <img src={imgTransport} className="pb-3" alt="" />
                  <p className="m-2 mt-0">Route Sections</p>
                  <span className="text-icon sky">
                    Open Setup <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </Link>
            </div>
          </div>

          <div className="card mt-4">
            <div className="card-body">
              <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-4">
                <div>
                  <h5 className="card-title mb-1">Buses Overview</h5>
                  <p className="text-muted small mb-0">
                    Click a bus to view its student attendance sheet
                  </p>
                </div>
                {!loadingBuses && busWiseCounts.length > 0 && (
                  <div className="d-flex flex-wrap gap-3">
                    <span className="badge rounded-pill text-bg-primary px-3 py-2">
                      {busWiseCounts.length} {busWiseCounts.length === 1 ? "Bus" : "Buses"}
                    </span>
                    <span className="badge rounded-pill text-bg-success px-3 py-2">
                      {totalBusStudents} Students
                    </span>
                  </div>
                )}
              </div>

              {loadingBuses ? (
                <div className="text-center py-5">
                  <Spinner animation="border" role="status" />
                </div>
              ) : busWiseCounts.length > 0 ? (
                <div className="row g-3">
                  {busWiseCounts.map((item, index) => {
                    const accent = busAccentColors[index % busAccentColors.length];

                    return (
                      <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6" key={`bus-card-${item.busNo}`}>
                        <Link
                          to={`/Transport/PrintBuswise-AttendenceSheet/?BusNumber=${encodeURIComponent(item.busNo)}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="card m-card h-100 border-0 shadow-sm text-decoration-none text-body"
                          style={{ borderTop: `4px solid ${accent}` }}
                        >
                          <div className="card-body text-center py-4">
                            <div
                              className="rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                              style={{
                                width: "56px",
                                height: "56px",
                                backgroundColor: `${accent}15`,
                                color: accent,
                              }}
                            >
                              <i className="ri-bus-2-line" style={{ fontSize: "1.75rem" }}></i>
                            </div>
                            <p className="text-muted small mb-1">Bus Number</p>
                            <h4 className="mb-2">{item.busNo}</h4>
                            <p className="mb-2">
                              <span className="fs-4 fw-semibold" style={{ color: accent }}>
                                {item.studentCount}
                              </span>
                              <span className="text-muted ms-1">
                                {item.studentCount === 1 ? "student" : "students"}
                              </span>
                            </p>
                            <span className="text-icon sky small">
                              View Students <i className="ri-arrow-right-line"></i>
                            </span>
                          </div>
                        </Link>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className="text-center py-5 text-muted">
                  <i className="ri-bus-2-line d-block mb-2" style={{ fontSize: "2rem" }}></i>
                  No bus routes with assigned students found.
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TransportDashboard;
